<<template>
  <div class="detail-panel">
    <div class="btn-panel">
        <a v-if="this.action != 'View'" class="btn btn-default" @click="save">{{$rs["btn_save"]}}</a>
      <slot></slot>
    </div>
      <hr>
      
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["roleNo"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.roleNo">
        </div>
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["roleName"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.roleName">
        </div>
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["remark"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.remark">
        </div>
    </div> 
    <div style="position: absolute; top:130px; left: 5px; right: 5px; bottom: 5px;overflow:auto;">
      <div class="row">
        <div class="input-group col-md-11">
          <span class="input-group-addon" >{{rs["rights"]}}</span>
          <div ref="rightsDiv" v-once class="form-control" style=" height: auto; margin-right: 10px;">
            <label v-for='its in getMenu(0)' style="margin-right: 10px;">
              <input type="checkbox" :value="its.autoid" @change="baseChange($event, its.seq)" v-model="data.rights" class="cb-rights"  />{{its.nameZh}}</label>
            <div v-for='it in getMenu(0)' v-show='data.rights.indexOf(it.autoid)>=0' :id='"menu" + it.seq' class="input-group col-md-12 cb-div" style="margin-left: 5px;">
              <span class="input-group-addon" >{{it.nameZh}}</span>
              <div class="form-control" style=" height: auto; margin-right: 10px;">
                <label v-for='ms in getMenu(it.seq)' style="margin-right: 10px;">
                  <input type="checkbox" :value="ms.autoid" v-model="data.rights" @change="baseChange($event, ms.seq)" class="cb-rights"  />{{ms.nameZh}}</label>
                <div v-for='mm in getMenu(it.seq)' v-if="getRights(mm.moduleNo).length>0" v-show='data.rights.indexOf(mm.autoid)>=0' :id='"menu" + mm.seq' class="input-group col-md-12 cb-div" style="margin-left: 5px;">
                  <label class="input-group-addon" ><input type="checkbox" @change="selectAll($event)" />{{mm.nameZh}}</label>
                  <div class="form-control" style=" height: auto; margin-right: 10px;">
                    <label v-for='xr in getRights(mm.moduleNo)' style="margin-right: 10px;">
                      <input type="checkbox" :value="xr.autoid" v-model="data.rights" class="cb-rights" />{{xr.rightsName}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  </div>
</template>

<<script>
import mixin from "../../mixin/detailMixin.js";
export default {
  /*created(){
    this.menuModel = this.menu.filter(r=>r.fseq==0)
    this.modelRights = []
    this.menuModel.forEach(d=>{
      if (this.data.rights.find(s=>s==d.rightsNo)) {
        this.modelRights.push(d.rightsNo)
        this.m0List.push(d)
      }
      this.menuMap.set(d.seq, this.menu.filter(r=>r.fseq==d.seq))
    })
  },*/
  props:["action", "detailData", "rs", "url","rightsList","xright", "menu"],
  data(){
    return {
      didx:-1,
      dm:null,
      mno: -1,
      mdm:null,
      baseList:[]
    }
  },
  methods: {
    selectAll(e){
      const tg = e.target.parentNode.parentNode.querySelectorAll(".cb-rights")
      if(tg && tg.length>0){
        const lh = tg.length
        let rs = false
        if(e.target.checked) rs=true
        for (let i=0; i<lh; i++){
          tg[i].checked = rs
        }
      }
    },
    baseChange(e, seq){
      const tg = e.target.parentNode.parentNode.querySelector("#menu" + seq)
      if(tg && e.target.checked) tg.style.display = ""
      else if (tg) {
        tg.style.display = "none"
        const list = tg.querySelectorAll(".cb-rights")
        const divs = tg.querySelectorAll(".cb-div")
        if (list && list.length>0){
          const lh = list.length
          for (let i=0; i<lh; i++) list[i].checked=false
        }
        if (divs && divs.length>0){
          const lh = divs.length
          for (let i=0; i<lh; i++) divs[i].style.display="none"
        }
      }
    },
    getRights(moduleNo){
      if (this.mno!=moduleNo){
        this.mno=moduleNo
        this.mdm= this.rightsList.filter(d=>d.moduleNo==moduleNo)
      }
      return this.mdm
    },
    getMenu(fseq){
      if (this.didx != fseq){
        this.didx = fseq
        this.dm=this.menu.filter(d=>d.fseq==fseq)
      }
      return this.dm
    },
    getMenuX(fseq){
      let list = this.getMenu(fseq)
      return list.filter(d=>this.data.rights.indexOf(d.autoid)>=0)
    },
    save:function(){
      if (!this.checkNull(this.data.roleNo, "nullNo")) return
      if (!this.checkNull(this.data.roleName, "nullName")) return

      const list = this.$refs.rightsDiv.querySelectorAll(".cb-rights:checked")
      const len = list.length
      const rights = []
      for (var i =0; i<len; i++) rights.push(list[i].value)

      const sd = {role: this.data, rights: rights}

      if (this.action == "Add" || this.action == "Copy") {
        this.$save(this.url + "AddX", sd, this.saveResult);
        
      } else if (this.action == "Edit") {
        this.$save(this.url + "EditX", sd, this.saveResult);
      }
    }
  },
  mixins:[mixin]
}
</script>

